import React from 'react';
import {
	Box,
	Divider,
	List,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Paper,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const SettingsNav = ({ items, activeSection, onSectionChange }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	if (isMobile) {
		return (
			<Paper
				variant="outlined"
				sx={{
					borderRadius: 2,
					overflow: 'hidden',
				}}
			>
				<List disablePadding>
					{items.map((item, index) => {
						const Icon = item.icon;
						return (
							<React.Fragment key={item.id}>
								{index > 0 ? <Divider component="li" /> : null}
								<ListItemButton
									onClick={() => onSectionChange(item.id)}
									sx={{ py: 1.5, px: 2 }}
								>
									<ListItemIcon
										sx={{
											minWidth: 40,
											color: 'primary.main',
										}}
									>
										<Icon fontSize="small" />
									</ListItemIcon>
									<ListItemText
										primary={item.label}
										secondary={item.description}
										primaryTypographyProps={{
											fontWeight: 600,
											fontSize: '0.95rem',
										}}
										secondaryTypographyProps={{
											fontSize: '0.75rem',
											sx: { mt: 0.15, lineHeight: 1.35 },
										}}
									/>
									<ChevronRightIcon
										sx={{ color: 'text.disabled', ml: 1 }}
										aria-hidden
									/>
								</ListItemButton>
							</React.Fragment>
						);
					})}
				</List>
			</Paper>
		);
	}

	return (
		<Box
			component="nav"
			sx={{
				width: 220,
				flexShrink: 0,
				position: 'sticky',
				top: 24,
				alignSelf: 'flex-start',
			}}
		>
			<Typography
				variant="overline"
				color="text.secondary"
				sx={{ display: 'block', mb: 1.5, letterSpacing: 1.2, px: 1 }}
			>
				Settings
			</Typography>
			<List
				disablePadding
				sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}
			>
				{items.map((item) => {
					const Icon = item.icon;
					const selected = activeSection === item.id;
					return (
						<ListItemButton
							key={item.id}
							selected={selected}
							onClick={() => onSectionChange(item.id)}
							sx={{
								borderRadius: 2,
								py: 1.25,
								'&.Mui-selected': {
									bgcolor: 'action.selected',
									'&:hover': { bgcolor: 'action.selected' },
								},
							}}
						>
							<ListItemIcon
								sx={{
									minWidth: 36,
									color: selected ? 'primary.main' : 'text.secondary',
								}}
							>
								<Icon fontSize="small" />
							</ListItemIcon>
							<ListItemText
								primary={item.label}
								secondary={item.description}
								primaryTypographyProps={{
									fontWeight: selected ? 700 : 600,
									fontSize: '0.9rem',
								}}
								secondaryTypographyProps={{
									fontSize: '0.72rem',
									sx: { mt: 0.25, lineHeight: 1.35 },
								}}
							/>
						</ListItemButton>
					);
				})}
			</List>
		</Box>
	);
};

export default SettingsNav;
